export const ASSOCIATED_LINKS_REDUCER_KEYS = {
  BY_ID: 'byId',
  REDUCER: 'associatedLinks',
}
